export const redirectToSsoProvider = ({
  from, provider, isGoogle, isMicrosoft,
}) => {
  let fromParam = '';
  if (from === 'datapeople-anywhere' || from.startsWith('help')) {
    fromParam = `?from=${from}`;
  }

  if (isGoogle) {
    window.location.href = `/signup/google${fromParam}`;
  } else if (isMicrosoft) {
    window.location.href = `/signup/microsoft${fromParam}`;
  } else {
    window.location.href = `/login/${provider}${fromParam}`;
  }
};
